<template>
    <div v-show='isShow' class='layer-pop square-type'>
        <div class='view-content'>
            <button class='close' @click='onClickBtnCancel'><span class='blind'>팝업 닫기</span></button>
            <div class='scroll-area com-scroll-y'>
                <span class='sub-title'>스케줄표 시간설정</span>
                <p class='sub-txt'>스케줄표에 보이는 시간을 설정합니다.</p>
                <div class='time-select-box'>
                    <select-form :select-data='[...hourList]'
                                 :select-value='[...hourList]'
                                 :selected-value='selected.startHour'
                                 @update:set='v => selected.startHour = v'></select-form>
                    <span class='dot'>:</span>
                    <select-form :disabled='true'
                                 :select-data='[...minList]'
                                 :select-value='[...minList]'
                                 :selected-value='startMin'></select-form>
                    <div class='com-dash'><span class='dash'>~</span></div>
                    <select-form :select-data='[...hourList]'
                                 :select-value='[...hourList]'
                                 :selected-value='selected.endHour'
                                 @update:set='v => selected.endHour = v'></select-form>
                    <span class='dot'>:</span>
                    <select-form :disabled='true'
                                 :select-data='[...minList]'
                                 :select-value='[...minList]'
                                 :selected-value='endMin'></select-form>
                </div>
                <p class='notice-txt'>[시 : 분] 단위 표시입니다.</p>
                <div class='bottom-btn'>
                    <button class='com-btn' @click='onClickBtnCancel'>취소</button>
                    <button class='com-btn blue' @click='onClickBtnConfirm'>이동</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Utils } from '@/assets/js/utils';

export default {
    name: 'ScheduleTimeSetterDlg',
    props: {
        isShow: Boolean,
        startHour: [Number, String],
        startMin: [Number, String],
        endHour: [Number, String],
        endMin: [Number, String],
        callbackCancel: Function,
        callbackConfirm: Function,
    },
    data() {
        return {
            hourList: [],
            minList: [],
            selected: {
                startHour: '07',
                endHour: '23',
            },
            search: {
                startHour: '07',
                endHour: '23',
            },
        };
    },
    mounted() {
        for (let h = 0; h < 24; h++) {
            this.hourList.push(h.toString().padStart(2, '0'));
        }
        for (let m = 0; m < 60; m += 10) {
            this.minList.push(m.toString().padStart(2, '0'));
        }

        this.hourList = Utils.getHourList();
        this.minList = Utils.getMinsList();

        this.search.startHour = this.startHour;
        this.search.endHour = this.endHour;
    },
    methods: {
        onClickBtnCancel() {
            // 시간 설정 팝업 취소 : 이전 셋팅 값을 복구
            const { search, selected } = this;
            selected.startHour = search.startHour;
            selected.endHour = search.endHour;

            if (!Utils.isEmpty(this.callbackCancel)) {
                this.callbackCancel(selected);
            }
        },
        onClickBtnConfirm() {
            // 시간 설정 팝업 확인 : 현재 셋팅 값으로 변경
            const { search, selected } = this;

            if (parseInt(selected.startHour) > parseInt(selected.endHour)) {
                alert('종료시간보다 시작시간이 클 수 없습니다.');
                return false;
            }

            search.startHour = selected.startHour;
            search.endHour = selected.endHour;

            if (!Utils.isEmpty(this.callbackConfirm)) {
                this.callbackConfirm({ ...this.search });
            }
        },
    },
};
</script>

<style scoped>

</style>
